var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBED0",
    fillRule: "nonzero",
    d: "M6.263 11.053a4.79 4.79 0 1 0 0-9.58 4.79 4.79 0 0 0 0 9.58zm0 1.473A6.263 6.263 0 1 1 6.263 0a6.263 6.263 0 0 1 0 12.526zm3.485-1.961a.577.577 0 0 1 .817-.817l3.266 3.266a.577.577 0 1 1-.817.817l-3.266-3.266z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7a2ee4d1.svg";
export { ForwardRef as ReactComponent };